<template>
  <view class="page-header-root">
    <view
      class="page-header-wrapper"
      :class="{ 'is-fixed': fixed }"
      :style="{ backgroundColor: 'transparent', backgroundImage: 'none' }"
    >
      <view v-if="showTopBar" class="lanhu-header">
        <view class="hdr-btn" @click="openSidebar">
          <image class="hdr-icon" :src="IMG.menu" mode="aspectFit" />
        </view>

        <view class="hdr-right">
          <view class="hdr-btn astralx-btn" @tap="openAstralx">
            <image class="astralx-logo" :src="IMG.astralx" mode="aspectFit" />
          </view>
          <!-- Lanhu group_3：白底圆钮 + 绿底猴头 logo → Panta Market -->
          <view class="hdr-btn profile-btn" @click="openPantaMarket">
            <image class="profile-logo" :src="IMG.profile" mode="aspectFit" />
          </view>

          <view v-if="showNotification" class="hdr-btn notify" @click="handleNotification">
            <view v-if="notifyBadge > 0" class="notify-badge">
              <text class="notify-badge-text">{{ notifyBadgeLabel }}</text>
            </view>
            <image class="hdr-icon" :src="IMG.bell" mode="aspectFit" />
          </view>

          <view v-if="showLang" class="hdr-btn" @click="handleLangSwitch">
            <image class="hdr-icon" :src="IMG.globe" mode="aspectFit" />
          </view>
        </view>
      </view>

      <view v-if="title" class="nav-bar">
        <view v-if="showBackButton" class="left-button" @click="handleBack">
          <image src="/static/image/asset/arrow.webp" class="back-arrow-img" mode="aspectFit" />
        </view>
        <view v-else class="left-button" />
        <text class="page-title" :style="{ color: titleColor }">{{ title }}</text>
        <view class="right-slot">
          <slot name="right"><view class="right-placeholder" /></slot>
        </view>
      </view>
    </view>

    <sidebar-menu :visible="showSidebar" @close="showSidebar = false" />
  </view>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import SidebarMenu from '@/components/sidebar-menu/index.vue';
import { useWalletStore } from '@/store/wallet';
import { useAnnouncementsStore } from '@/store/announcements';
import { navigateBackOrHome } from '@/common/utils/navigation';
import { triggerLogin } from '@/common/auth';
import { BRAND_LOGO } from '@/common/constants/brand';
const IMG = {
  menu: '/static/image/lanhu/home/icon-menu.webp',
  astralx: '/static/image/lanhu/home/astralx-mark.webp',
  profile: BRAND_LOGO,
  chevron: '/static/image/lanhu/home/icon-arrow.webp',
  bell: '/static/image/lanhu/home/icon-bell.webp',
  globe: '/static/image/lanhu/home/icon-lang.webp',
};

defineProps({
  title: { type: String, default: '' },
  bgColor: { type: String, default: 'transparent' },
  titleColor: { type: String, default: '#333333' },
  showLang: { type: Boolean, default: true },
  showNotification: { type: Boolean, default: true },
  hasNotification: { type: Boolean, default: true },
  showTopBar: { type: Boolean, default: true },
  showBackButton: { type: Boolean, default: true },
  fixed: { type: Boolean, default: false },
});

const emit = defineEmits(['back']);
const showSidebar = ref(false);
const walletStore = useWalletStore();
const annStore = useAnnouncementsStore();
const { badgeCount: notifyBadge } = storeToRefs(annStore);
const notifyBadgeLabel = computed(() => {
  const n = notifyBadge.value;
  return n > 99 ? '99+' : String(n);
});

const openSidebar = () => {
  showSidebar.value = true;
  void annStore.fetchUnreadCount();
};
const openPantaMarket = () => {
  uni.navigateTo({ url: '/pages/panta-market/index' });
};
const handleNotification = () => {
  if (!walletStore.isAuthenticated) {
    triggerLogin();
    return;
  }
  uni.navigateTo({ url: '/pages/notice/index' });
};
const handleLangSwitch = () => {
  uni.navigateTo({ url: '/pages/language/index' });
};
const openAstralx = () => {
  const url = 'https://www.astralx.com';

  window.open(url, '_blank');












};
const handleBack = () => {
  emit('back');
  navigateBackOrHome();
};
</script>

<style scoped lang="scss">
/* 严格按 Lanhu box_2：750 设计稿 1px=1rpx */
.page-header-root {
  width: 100%;
}

.page-header-wrapper {
  padding-top: var(--status-bar-height, 0px);
  flex-shrink: 0;
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  pointer-events: none;

  &.is-fixed {
    position: fixed;
    top: 0;
    left: 50%;
    right: auto;
    width: 100%;
    max-width: var(--app-max-width, 750px);
    transform: translateX(-50%);
    z-index: 1000;
    background: transparent !important;
    background-image: none !important;
  }

  /* 仅交互区域可点，避免挡滚动 */
  .lanhu-header,
  .nav-bar,
  .hdr-btn,
  .profile-btn,
  .left-button,
  .right-slot {
    pointer-events: auto;
  }
}

.lanhu-header {
  height: auto;
  min-height: 82rpx;
  padding: 6px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: transparent !important;
  background-image: none !important;
}

/* Lanhu image-wrapper_1 / group_3 / image-wrapper_3：82 白底圆钮 */
.hdr-btn {
  width: 82rpx;
  height: 82rpx;
  border-radius: 50%;
  background: #ffffff;
  border: 1rpx solid #e8ecf1;
  box-shadow: 0 4rpx 12rpx rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  transition: transform 0.15s ease, background-color 0.15s ease;

  &:active {
    transform: scale(0.92);
    background: #f7f8fa;
  }

  .hdr-icon {
    width: 48rpx;
    height: 48rpx;
  }
}

.hdr-right {
  display: flex;
  align-items: center;
  gap: 16rpx;
}

/* AstralX 纯标：与右侧猴头同款白底圆钮 + 尺寸 */
.astralx-btn {
  .astralx-logo {
    width: 40rpx;
    height: 40rpx;
    display: block;
  }
}

/* Lanhu group_3 / group_5：白圆钮内 48 绿底个人信息 logo */
.profile-btn {
  .profile-logo {
    width: 48rpx;
    height: 48rpx;
    border-radius: 50%;
    display: block;
  }
}

.notify {
  .red-dot {
    position: absolute;
    top: 2rpx;
    right: 2rpx;
    width: 10rpx;
    height: 10rpx;
    border-radius: 50%;
    background: #f73a3a;
    z-index: 1;
  }

  .notify-badge {
    position: absolute;
    top: -4rpx;
    right: -6rpx;
    min-width: 28rpx;
    height: 28rpx;
    padding: 0 6rpx;
    border-radius: 999rpx;
    background: #f73a3a;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    box-sizing: border-box;
  }

  .notify-badge-text {
    font-size: 18rpx;
    color: #ffffff;
    font-weight: 600;
    line-height: 1;
  }
}

.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  height: var(--app-sub-header-height, 58px);
  position: relative;

  .left-button {
    width: 48rpx;
    height: 48rpx;
    display: flex;
    align-items: center;
    justify-content: center;
    .back-arrow-img {
      width: 28rpx;
      height: 28rpx;
    }
  }

  .page-title {
    font-size: 34rpx;
    font-weight: 600;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .right-slot {
    min-width: 48rpx;
  }
  .right-placeholder {
    width: 48rpx;
  }
}
</style>
